import { isBoolean } from 'lodash/fp';
import { PropTypes } from 'prop-types';
import { InputSubLabel } from '../InputSubLabel';

export default function InputError({ error }) {
    return (
        <InputSubLabel show={!!error && !isBoolean(error)} isError>
            {error}
        </InputSubLabel>
    );
}

InputError.propTypes = {
    error: PropTypes.any,
};
